import { ObservationRenderFragment } from '@eluve/fhir-renderer';
import { graphql } from '@eluve/graphql-fhir';

/**
 * FHIR Patient lookup by Eluve patient identifier (the Hasura patient id the
 * profile route carries). Mirrors the profile shell's provisioning query but
 * only needs the id — the observations card keys everything off the FHIR id.
 */
export const FHIR_PATIENT_ID_QUERY = graphql(`
  query FhirObservationsPatientId($identifier: String!) {
    PatientList(identifier: $identifier, _count: 1) {
      id
    }
  }
`);

/**
 * The patient's observations, newest first, one bounded page per explicit
 * loadMore (never fetch-all — the series/sparklines are derived from the
 * loaded window by design). Selections come from the entity's render
 * fragment so the renderer's display contract stays the single source.
 */
export const PATIENT_OBSERVATIONS_QUERY = graphql(
  `
    query FhirPatientObservations($patientRef: String!, $offset: Int) {
      ObservationConnection(
        patient: $patientRef
        _count: 100
        _offset: $offset
        _sort: "-date"
      ) {
        count
        offset
        edges {
          resource {
            ...ObservationRender
          }
        }
      }
    }
  `,
  [ObservationRenderFragment],
);
